// eslint-disable-next-line @ms/forbid-file-names
import type { ComponentsStyles, IRawStyle, ITheme } from '../styling';
import { memoizeFunction } from '../styling';

import { tokens } from './fluent9';

const boxSizingRootStyles: IRawStyle = {
  boxSizing: 'border-box',
};

const boxSizingChildStyles: IRawStyle = {
  boxSizing: 'inherit',
};

const contextualMenuItemCommonStyles = {
  lineHeight: 'inherit',
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
};

export const getDefaultTypographyStyles = (theme: ITheme, useTransparentBackground: boolean): IRawStyle => ({
  ...theme.fonts.mediumPlus,
  color: tokens.colorNeutralForeground1,
  backgroundColor: useTransparentBackground ? tokens.colorTransparentBackground : tokens.colorNeutralBackground2,
  WebkitTextSizeAdjust: '100%',
});

export const getGlobalComponentStyleOverrides: (theme: ITheme) => ComponentsStyles = memoizeFunction(
  (theme: ITheme): ComponentsStyles => ({
    // Applying same global app container styles into modal dialog
    // since when suppressing the global styles, the modal dialog
    // don't share the same root element (it's added at the end of the DOM)
    // and so doesn't have the styles applied.
    Modal: {
      styles: {
        root: {
          ...getDefaultTypographyStyles(theme, true),
          ...boxSizingRootStyles,

          selectors: {
            '*, *::before, *::after': boxSizingChildStyles,
          },
        },
      },
    },

    // Outlook Web overrides the FluentUI Icon style, this ensures display:inline-block is correctly applied to our componen tree.
    // https://outlookweb.visualstudio.com/Outlook%20Web/_git/client-web?path=%2Fpackages%2Fframework%2Fowa-fabric-theme%2Flib%2Forchestrators%2FapplyCustomScopedSettings.ts&version=GBmaster&line=12&lineEnd=23&lineStartColumn=1&lineEndColumn=1&lineStyle=plain
    Icon: {
      styles: { root: { display: 'inline-block' } },
    },
    ContextualMenu: {
      styles: {
        root: {
          selectors: {
            '.ms-ContextualMenu-item': {
              display: 'block',
            },
            '.ms-ContextualMenu-link': contextualMenuItemCommonStyles,
            '.ms-ContextualMenu-header': contextualMenuItemCommonStyles,
            '.ms-ContextualMenu-linkContent': {
              lineHeight: 'inherit',
              height: 'auto',
              paddingTop: 8,
              paddingBottom: 8,
            },
          },
        },
      },
    },
  })
);
